/**
 * Normaliza un monto a número. El backend mezcla representaciones según el
 * campo: algunos llegan como `number`, otros como `string` formateado
 * (`"CRC 1,500"`, `"1,500.00"`) o como string crudo (`"1500"`). Esta función
 * extrae los dígitos, signo y punto decimal, devolviendo `0` cuando no se
 * puede parsear (en lugar de NaN, que rompería las sumas/comparaciones).
 *
 * Uso esperado: lados del front que muestran totales o suman montos del
 * payload de Preorder/PreorderLine sin asumir un tipo concreto.
 */
export function toAmount(value: number | string | null | undefined): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
  if (typeof value !== 'string') return 0;
  const cleaned = value.replace(/[^0-9.-]/g, '');
  const num = parseFloat(cleaned);
  return Number.isFinite(num) ? num : 0;
}
